<ng-container *transloco="let t; read: 'providers.detailPage'">
  <div class="h-full min-h-0 overflow-auto p-6">
    <div class="mx-auto grid max-w-[1180px] items-start gap-6" style="grid-template-columns: minmax(0, 1fr) 380px">
      <div class="flex flex-col gap-6">
        <!-- Provider: what discovery reports. All of it comes from the provider's descriptor, so it's read-only. -->
        <div class="rounded-card bg-card p-6 shadow-hairline">
          <div class="mb-1.5 font-display text-[12px] font-semibold uppercase tracking-wide text-ink-2">{{ t('cards.provider') }}</div>
          <p class="mb-5 mt-0 text-[13px] text-ink-3">{{ t('discoveredNote') }}</p>

          @if (provider(); as p) {
            <div class="grid grid-cols-[160px_1fr] items-start gap-x-4 gap-y-3.5 text-[13px]">
              <span class="text-[11px] uppercase tracking-wide text-ink-3">{{ t('fields.name') }}</span>
              <span class="text-ink-1">{{ p.name }}</span>

              <span class="text-[11px] uppercase tracking-wide text-ink-3">{{ t('fields.serviceUrl') }}</span>
              <span class="break-all font-num text-[12px] text-ink-1">{{ p.serviceUrl }}</span>

              <span class="text-[11px] uppercase tracking-wide text-ink-3">{{ t('fields.discovery') }}</span>
              <div class="flex flex-col items-start gap-1.5">
                <app-label-badge [dot]="discoveryDot()">{{ discoveryLabel() }}</app-label-badge>
                @if (p.lastDiscoveryError) {
                  <span class="break-words text-[12px] text-danger">{{ p.lastDiscoveryError }}</span>
                }
                @if (p.discoveryState && p.discoveryState !== 'READY') {
                  <span class="text-[12px] text-ink-3">{{ t('discoveryKeepsDescriptor') }}</span>
                }
              </div>

              <span class="text-[11px] uppercase tracking-wide text-ink-3">{{ t('fields.lastDiscovered') }}</span>
              <span class="text-ink-1">{{ p.lastDiscoveredAt ? (p.lastDiscoveredAt | date: 'medium') : t('dash') }}</span>

              <span class="text-[11px] uppercase tracking-wide text-ink-3">{{ t('fields.version') }}</span>
              <span class="break-all font-num text-[12px] text-ink-1">{{ p.providerVersion ?? t('dash') }}</span>

              <span class="text-[11px] uppercase tracking-wide text-ink-3">{{ t('fields.resourceDiscovery') }}</span>
              <span class="text-ink-1">{{ p.supportsResourceDiscovery ? t('yes') : t('no') }}</span>

              <span class="text-[11px] uppercase tracking-wide text-ink-3">{{ t('fields.files') }}</span>
              <div class="flex flex-col gap-1.5 text-ink-1">
                @if (!p.acceptsFiles) {
                  <span>{{ t('no') }}</span>
                } @else if (files(); as f) {
                  <span>{{ f.contentTypes?.length ? f.contentTypes!.join(', ') : t('filesAnyType') }}</span>
                  @if (f.roles?.length) {
                    <div class="flex flex-wrap gap-1.5">
                      @for (role of f.roles; track role.name) {
                        <app-label-badge [dot]="role.required ? 'blue' : null">{{ role.required ? t('roleRequired', { role: role.name }) : role.name }}</app-label-badge>
                      }
                    </div>
                  }
                } @else {
                  <span>{{ t('yes') }}</span>
                }
              </div>
            </div>
          }

          <div class="mt-5 flex items-center border-t border-hairline pt-5">
            <div class="flex-1"></div>
            <button
              type="button"
              (click)="confirmDelete()"
              class="border-none bg-transparent text-[13px] font-semibold text-danger hover:underline"
            >
              {{ t('actions.deleteProvider') }}
            </button>
          </div>
        </div>

        <!-- Type-specific cards (e.g. SIRI stop health) -->
        <ng-content />
      </div>

      <div class="flex flex-col gap-6">
        <!-- Record -->
        <div class="rounded-card bg-card p-6 shadow-hairline">
          <div class="mb-4 font-display text-[12px] font-semibold uppercase tracking-wide text-ink-2">{{ t('cards.record') }}</div>
          @if (provider(); as p) {
            <div class="grid grid-cols-[100px_1fr] items-start gap-x-3 gap-y-3.5 text-[13px]">
              <span class="text-[11px] uppercase tracking-wide text-ink-3">{{ t('fields.providerId') }}</span>
              <span class="break-all font-num text-[12px] text-ink-2">{{ p.id }}</span>

              <span class="text-[11px] uppercase tracking-wide text-ink-3">{{ t('fields.type') }}</span>
              <span class="break-all font-num text-[12px] text-ink-1">{{ p.type }}</span>

              <span class="text-[11px] uppercase tracking-wide text-ink-3">{{ t('fields.created') }}</span>
              <span class="text-ink-1">{{ p.createdAt | date: 'mediumDate' }}</span>

              <span class="text-[11px] uppercase tracking-wide text-ink-3">{{ t('fields.updated') }}</span>
              <span class="text-ink-1">{{ p.updatedAt | date: 'mediumDate' }}</span>
            </div>
          }
        </div>

        <!-- Feeds by tenant -->
        <div class="rounded-card bg-card p-6 shadow-hairline">
          <div class="mb-4 flex items-baseline justify-between">
            <span class="font-display text-[12px] font-semibold uppercase tracking-wide text-ink-2">{{ t('cards.feedsByTenant') }}</span>
            <span class="font-display text-2xl font-semibold text-ink-1">{{ totalFeeds().length }}</span>
          </div>
          @for (entry of feedsByTenant(); track entry.tenantId) {
            <div class="flex items-center justify-between border-b border-hairline py-2.5 last:border-b-0">
              <span class="truncate text-[13px] text-ink-2">{{ entry.name }}</span>
              <span class="text-[13px] font-semibold text-ink-1">{{ entry.count }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</ng-container>
